export default "__VITE_ASSET__GDzgF2js__"